module.exports = __webpack_public_path__ + "img/jpeg.cb510005.svg";